import { BuildingUpdatableInterface } from '../interfaces/building-updatable.interface';
import { PartialType, PickType } from '@nestjs/swagger';
import { BuildingDto } from './building.dto';

export class BuildingUpdateDto
  extends PartialType(PickType(BuildingDto, ['number', 'notes']))
  implements BuildingUpdatableInterface {}
